angular.module('leanlaw').directive('back', ['$window', function ($window) {
  return {
    restrict: 'A',
    link(scope, elem) {
      elem.bind('click', () => {
        $window.history.back();
      });
    }
  };
}]);